import { RouteInterface } from '@/src/common/enums/routes'

export const PointsToOmniRoutes = {
  PartnerDetail: {
    route: '/main/points-to-omni/partner-detail',
    name: 'Omni Hotels & Resorts',
    availableForDeepLinking: true,
  },
  PointsTransfer: {
    route: '/main/points-to-omni/points-transfer',
    name: 'Transfer Points to Omni',
    availableForDeepLinking: false,
  },
  TransferConfirmation: {
    route: '/main/points-to-omni/transfer-confirmation',
    name: 'Select Transfer Amount',
    availableForDeepLinking: false,
  },
  RedemptionConfirmation: {
    route: '/main/points-to-omni/redemption-confirmation',
    name: 'Confirm Points Transfer',
    availableForDeepLinking: false,
  },
  TransferSuccess: {
    route: '/main/points-to-omni/transfer-success',
    name: 'Omni Transfer Success',
    availableForDeepLinking: false,
  },
} as const satisfies Record<string, RouteInterface>
